import { combineEpics } from 'redux-observable';

import { createEventParentCategoryEpic }   from './CreateEventParentCategory/CreateEventParentCategoryEpic';
import { deleteEventParentCategoryEpic }   from './DeleteEventParentCategory/DeleteEventParentCategoryEpic';
import { findEventParentCategoriesEpic }   from './FindEventParentCategories/FindEventParentCategoriesEpic';
import { searchEventParentCategoriesEpic } from './SearchEventParentCategories/SearchEventParentCategoriesEpic';
import { findEventParentCategoryEpic }     from './FindEventParentCategory/FindEventParentCategoryEpic';
import { updateEventParentCategoryEpic }   from './UpdateEventParentCategory/UpdateEventParentCategoryEpic';


export const eventParentCategoryEpics = combineEpics(
  createEventParentCategoryEpic,
  deleteEventParentCategoryEpic,
  searchEventParentCategoriesEpic,
  findEventParentCategoriesEpic,
  findEventParentCategoryEpic,
  updateEventParentCategoryEpic,
);
